<template>
    <div class="phone-signed">
        <div v-if="isSave" class="phone-signed-modal signed-success">
            <div class="wrap">
                <img src="@/assets/img/icon/success_done.svg" alt="">
                <h1>手機簽名設定完成</h1>
                <div class="description">
                    重新整理飛豬管家的網頁後，您的手機簽名設定即完成
                </div>
            </div>
        </div>
        <div v-if="errorMsg" class="phone-signed-modal signed-error">
            <div class="wrap">
                <img src="@/assets/img/icon/alarm_msg_error.svg" alt="">
                <h1>{{errorMsg}}</h1>
            </div>
        </div>
        <div class="phone-signed-header">
            <div class="phone-signed-clear" @click="canvasClear">清除</div>
            <div class="phone-signed-title">在下列方框中簽名</div>
            <div class="phone-signed-save" @click="setUserSignature">完成</div>
        </div>
        <sign-canvas :key="componentKey" class="phone-signed-body" ref="SignCanvas" :options="options" v-model="value"/>
    </div>
</template>
<script>
import SignCanvas from 'sign-canvas';
import { mapGetters } from 'vuex'
import { 
    apiBizUploadSignature
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            value: null,
            isSave: false,
            errorMsg: null,
            componentKey: 0,
            options:{
                isFullScreen: true,
                isFullCover: true,
                isDpr: false,       //是否使用dpr兼容高倍屏 [Boolean] 可选
                lastWriteSpeed: 1,  //书写速度 [Number] 可选
                lastWriteWidth: 2,  //下笔的宽度 [Number] 可选
                lineCap: 'round',   //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
                lineJoin: 'bevel',  //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
                canvasWidth: 380, //canvas宽高 [Number] 可选
                canvasHeight: 208,  //高度  [Number] 可选
                isShowBorder: false, //是否显示边框 [可选]
                bgColor: '#f6f6f6', //背景色 [String] 可选
                borderWidth: 1, // 网格线宽度  [Number] 可选
                writeWidth: 5, //基础轨迹宽度  [Number] 可选
                maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
                minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
                writeColor: '#292625', // 轨迹颜色  [String] 可选
                isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
                imgType:'png'   //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
            }
        }
    },
    mounted () {
        document.documentElement.style.overflowY = 'hidden'; 
        document.documentElement.style.overflowX = 'hidden'; 
        this.options.canvasWidth = window.innerWidth
        this.options.canvasHeight = window.innerHeight
        window.addEventListener("orientationchange", this.handleOrientation, false);
        this.changeAngle()
    },
    methods:{
        /**
         * 清除画板
         */
        canvasClear(){
            this.$refs.SignCanvas.canvasClear();
        },
        /**
         * 保存图片
         */
        saveAsImg(){
            let _self = this
            const img = this.$refs.SignCanvas.saveAsImg();
            _self.$store.dispatch('setSignData',{type: 'sign', value: img})
            .then( () => {
                // _self.$refs.signBtn.style.display = 'none'
                _self.isSave = true
                console.log(_self.isSave)
            })
        },
        handleOrientation(event) {
            location.reload();
            this.changeAngle()
        },
        changeAngle () {
            var mql = window.matchMedia("(orientation: portrait)");
            // If there are matches, we're in portrait
            if(mql.matches) {  
                this.errorMsg = '行動裝置請轉為橫向'
                // Portrait orientation
            } else {  
                this.errorMsg = null
                // Landscape orientation
            }

            // Add a media query change listener
            // mql.addListener(function(m) {
            //     if(m.matches) {
            //         this.errorMsg = '行動裝置請轉為橫向'
            //         // Changed to portrait
            //     }
            //     else {
            //         this.errorMsg = null
            //         // Changed to landscape
            //     }
            // });
            // if(screen.orientation.angle === 0){
            //     this.errorMsg = '行動裝置請轉為橫向'
            // }else if(screen.orientation.angle === 90){
            //     this.errorMsg = null
            // }
        },
        setUserSignature: function () {
            let formData = new FormData();
            formData.append('account', this.$route.query.account);
            formData.append('signatureCode', this.$route.query.code);
            formData.append('signature', this.value);
            formData.append('check', true);

            apiBizUploadSignature(formData)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.isSave = true
                }else if(res.data.errorCode === 251051 || res.data.errorCode === 251050){
                    this.errorMsg = '已逾時，請重新掃描QRCode'
                }
            })
        },
        
    },
    computed: {
        ...mapGetters({
            userAccount: 'GET_BIZ_USER_ACCOUNT',
        })
    },
    components: {
        SignCanvas
    }
}
</script>
<style lang="scss" scoped>
.phone-signed{
    .phone-signed-modal{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9;
        >.wrap {
            position: fixed;
            text-align: center;
            border-radius: 20px;
            background-color: #ffffff;
            box-sizing: border-box;
        }
    }
    .signed-success{
        >.wrap {
            width: 408px;
            height: 246px;
            padding: 40px 0;
            >img{
                width: 50px;
                margin-bottom: 24px;
            }
            >h1{
                font-size: 24px;
                margin-bottom: 24px;
            }
            .description{
                color: #676362;
                margin-bottom: 20px;
            }
        }
    }
    .signed-error{
        >.wrap {
            width: 290px;
            height: 200px;
            padding: 40px 0;
            >img{
                width: 50px;
                margin-bottom: 24px;
            }
            >h1{
                font-size: 24px;
            }
        }
    }
    .phone-signed-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        background: #FF9275;
        padding: 0 20px;
        width: 100%;
        height: 10vh;
        box-sizing: border-box;
        .phone-signed-title{
            font-size: 16px;
            font-weight: 500;
        }
    }
    .phone-signed-body{
        width: 100%;
        height: 100%;
        background: #ccc;
    }
}
// @media screen and (orientation: portrait) { 
//     html{ width : 100vmin; height : 100vmax; } 
//     body{ width : 100vmin; height : 100vmax; } 
//     #app{ width : 100vmin; height : 100vmax; } 
//     .phone-signed-header{width : 100vh; height: 17vw;}
//     .phone-signed{transform-origin: top left; transform: rotate(90deg) translate(0,-100vmin); } 
//     .phone-signed-body{transform-origin: top right; transform: rotate(-90deg) translate(0,-100vmin); } 
//     .signed-success{
//         width: 100vh;
//         height: 100%;
//         transform-origin: top right; 
//         transform: rotate(0deg) translate(0,-100vmin);
//         >.wrap{
//             top: 54%;
//         }
//     }
// } 
// @media screen and (orientation: landscape) { 
//     html{ width : 100vmax; height : 100vmin; } 
//     body{ width : 100vmax; height : 100vmin; } 
//     #app{ width : 100vmax; height : 100vmin; } 
//     .phone-signed-header{width : 100vw;height: 8vw;}
//     .signed-success{
//         width: 100vw;
//         height: 100%;
//         transform-origin: top right; 
//         transform: rotate(0deg) translate(0,-100vmin);
//         >.wrap{
//             top: 416px;
//         }
//     }
// }

</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/leaseMgt/phoneSigned.vue